<div class="d-none" style="height: 40px; width: 330px; border-radius: 8px;display: none !important;"
    class="d-flex align-items-center justify-content-start m-0 p-0 bg-grey6">
    <input type="search" class="form-control search_field border-0" placeholder="Search any page..." />
</div>